import { RefObject, useEffect, useRef } from "react";

// Чтобы иметь возможность фокусировать элементы извне (н.р. в сторе)
// Компонент, в котором лежит фокусируемый элемент, имеет такой пропс:
//   activateCallback?: ActivateCallback;
// Кроме того, компонент передаёт наружу функцию фокусировки.
// Примерно так:
//   const iref = useActivateCallback<InputRef>(activateCallback, (ref) => () => ref?.focus())
//   ...
//   <Input ref={myRef} ... />

export type FnOnActive = (() => void) | undefined;
export type ActivateCallback = (onActive: FnOnActive) => void;

/**
 * Данный хук должен быть один на компонент. Ну или у них должны быть разные activateCallback
 * Иначе callback перетирается
 * @param activateCallback
 * @param action
 * @returns
 */
export const useActivateCallback = <TRef>(
  activateCallback: ActivateCallback | undefined,
  action: (ref: TRef | null) => FnOnActive,
): RefObject<TRef | null> => {
  const refInst = useRef(null);
  useEffect(() => {
    activateCallback?.(action(refInst.current));
    return () => {
      activateCallback?.(undefined);
    };
  }, [refInst.current]);
  return refInst;
};
